import script from "./OrderProductCross.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderProductCross.vue?vue&type=script&setup=true&lang=js"

import "./OrderProductCross.vue?vue&type=style&index=0&id=2105a932&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2105a932"]])

export default __exports__